/**
 * Version de la aplicacion web.
 *
 * La interfaz la lee desde aqui; `bootstrap.test.ts` verifica que no se
 * desincronice del `package.json`.
 */
export const APP_VERSION = '0.0.1';
